export const requiresTosAcceptance = ({ user, tosUpdateRequired }) => {
  if (!user) return false;
  if (typeof tosUpdateRequired === "boolean") {
    return tosUpdateRequired;
  }
  return !user.accepted_tos;
};

export const isTosReacceptance = ({ user, tosUpdateRequired }) => {
  return (
    requiresTosAcceptance({ user, tosUpdateRequired }) &&
    Boolean(user && user.accepted_tos)
  );
};
